<template>
  <b-row class="px-5">
    <b-col cols="12" md="6" class=" mt-5">
      <img
          :src="restaurantObj.image"
          class="rounded-lg img-fluid w-100 mt-5"
          :alt="restaurantObj.name"/>
    </b-col>

    <b-col cols="12" md="6" class="">
      <b-row class="mt-5"><h1 class="mx-auto secondary-text">{{ restaurantObj.name }}</h1></b-row>
      <b-row class="mt-5 pt-5">
        <b-col md="6" xs="12" class="p-5 border-left border-danger"></b-col>
        <b-col md="6" xs="12" class="p-5 border-right border-danger">
          <h2 class="font-weight-bolder text-1">چه زمانی باز است</h2>

          <p class="h4 text-2" v-if="restaurantObj.timable.length === 0">
            همه روزه از 10 صبح تا 23 شب</p>

          <p class="h4 text-2 border-bottom border-dark pb-2" v-else v-for="timing in restaurantObj.timable" :key="timing.id">

            <span>از : </span>
            <span class="time-text">{{convertToJalaliWithTime(timing.open_at, '/')}}</span>
            <br/>
            <span>تا : </span>
            <span class="time-text">{{convertToJalaliWithTime(timing.close_at, '/')}}</span>

          </p>

        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col xs="12" md="6" class="p-5 border-left border-danger text-left">
          <h2 class="font-weight-bolder text-1">آدرسش کجاست</h2>
          <p class="h4 text-2">دزفول خیابان شریعتی</p>
        </b-col>
        <b-col xs="12" md="6" class="p-5 border-right border-danger"></b-col>
      </b-row>
    </b-col>

  </b-row>
</template>
<script>
import {convertToJalaliWithTime} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter"

export default {
  name: "S12",
  props:['restaurantSlug'],
  data() {
    return {
      restaurantObj: "",
    }
  },
  methods:{
    convertToJalaliWithTime
  },
  async mounted() {
    let form = {slug: this.restaurantSlug}
    await this.$store.dispatch("Brand/showBrand", form).then(res => {
      this.restaurantObj = res.data.data
    })
  }
}
</script>

<style scoped>
.time-text{
  font-size: 19px;
  direction: ltr;
}
</style>
